import { Lamp } from '../types/lamp';

type LampCommandType = 'ADD_LAMP' | 'ADD_LAMPS' | 'REMOVE_LAMP' | 'REMOVE_LAMPS' | 'MOVE_LAMP';

interface LampCommand {
  type: LampCommandType;
  data: {
    lamp?: Lamp;
    lamps?: Lamp[];
    lampId?: string;
    oldPosition?: [number, number, number];
    newPosition?: [number, number, number];
  };
}

export interface LampHistoryState {
  undoStack: LampCommand[];
  redoStack: LampCommand[];
}

export const initialLampHistoryState: LampHistoryState = {
  undoStack: [],
  redoStack: [],
};
